import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select, TextField } from '@material-ui/core';

export function VariableModal({ setOpen, variables, dropdownValue, setDropdownValue, indexValue, setIndexValue, handleAddClick, setOpenVariable, include, exclude }) {
  const { t } = useTranslation();
  const [showIndexInput, setShowIndexInput] = useState(false);
  const [variableList, setVariableList] = useState(variables);

  useEffect(() => {
    let isInclude = false;
    if (include) {
      setVariableList(variables.filter((x) => include.includes(x.type)));
      isInclude = true;
    }
    else { setVariableList(variables); }
    if (exclude) { setVariableList(variables.filter((x) => !exclude.includes(x.type))); }
    else if (!isInclude) {
      setVariableList(variables);
    }
    if (dropdownValue?.type === 'Array') {
      setShowIndexInput(true);
    }

  }, [variables, include, setVariableList, exclude, dropdownValue?.type])

  const handleVariableChange = (event) => {
    setDropdownValue(event.target.value);
    if (event.target.value.type === 'array') {
      setShowIndexInput(true);
    }
    else { setShowIndexInput(false); }
  }

  const handleIndexChange = (event) => {
    if (event.target.value >= 0) {
      setIndexValue(event.target.value);
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={true} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">
        <div id="about-title">
          {t('CONTENT.CONFIGURATION-FORM.VARIABLES')}
        </div>
      </DialogTitle>
      <DialogContent style={{ width: 300 }}>
        <p className="modal-text">{t('CONTENT.AUTOMS-LIST.CHOOSE-VARIABLE')}</p>
        <Select value={dropdownValue} onChange={handleVariableChange} variant="outlined" fullWidth style={{ marginBottom: 20 }} >
          {variableList?.length > 0 && JSON.stringify(variableList[0]) !== '{}' ? variableList.map((item, itemI) =>
            <MenuItem key={itemI} value={item}>{item.display_name ? item.display_name : item.name}</MenuItem>
          ) :
            <MenuItem button onClick={() => setOpenVariable({ type: "open", id: "" })} value="">{t('CONTENT.AUTOMS-LIST.ADD-NEW-VARIABLES')}</MenuItem>
          }
        </Select>
        {showIndexInput &&
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>{t('CONTENT.CONFIGURATION-FORM.INDEX')}:</div>
            <TextField
              variant="outlined"
              onChange={handleIndexChange}
              value={indexValue} type="number"
            ></TextField>
          </div>
        }
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          onClick={handleClose}
          variant="outlined"
          style={{ backgroundColor: "#BBBBBB", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
          {t('CONTENT.USER.CANCEL')}
        </Button>
        <Button
          onClick={handleAddClick}
          variant="outlined"
          style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
          {t('CONTENT.CONFIGURATION-FORM.ADD')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
